import { render, staticRenderFns } from "./PathsPage.vue?vue&type=template&id=36f2a026&scoped=true&"
import script from "./PathsPage.vue?vue&type=script&lang=js&"
export * from "./PathsPage.vue?vue&type=script&lang=js&"
import style0 from "./PathsPage.vue?vue&type=style&index=0&id=36f2a026&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f2a026",
  null
  
)

export default component.exports